import React from 'react';
import './Footer.scss';

const NAV_LINKS = [
  { href: '#prices',     label: 'Prices' },
  { href: '#finder',     label: 'Finder' },
  { href: '#fuel-guide', label: 'Fuel Guide' },
  { href: '#reg',        label: 'My Car' },
  { href: '#alerts',     label: 'Alerts' },
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__top">
          <div className="footer__brand">
            <div className="footer__logo">TTT</div>
            <p className="footer__tagline">
              UK's real-time fuel price Checker.
              <br />Powered by the official Government Fuel Finder Scheme.
            </p>
          </div>

          <nav className="footer__nav">
            <p className="footer__nav-title">Navigate</p>
            {NAV_LINKS.map(({ href, label }) => (
              <a key={href} href={href} className="footer__nav-link">{label}</a>
            ))}
          </nav>

          <div className="footer__data">
            <p className="footer__nav-title">Data Sources</p>
            <a
              href="https://www.gov.uk/guidance/access-fuel-price-data"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__nav-link"
            >
              UK Gov Fuel Finder Scheme
            </a>
            <a
              href="https://www.gov.uk/government/statistics/weekly-road-fuel-prices"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__nav-link"
            >
              DESNZ Weekly Prices
            </a>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copy">
            © 2026 TTT · Fuel price data provided as-is. Always verify before purchasing.
          </p>
          <p className="footer__credit">
            Designed by{' '}
            <a
              href="https://tadeyemi.co.uk"
              target="_blank"
              rel="noopener noreferrer"
              className="footer__credit-link"
            >
              Taiwo
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
